var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPipelinePause = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.48,
    d: "M9.818 16.91V7.09c0-.872-.727-1.09-1.09-1.09H7.09C6.218 6 6 6.727 6 7.09v9.82c0 .872.727 1.09 1.09 1.09h1.637c.873 0 1.091-.727 1.091-1.09Zm8.182 0V7.09C18 6.219 17.273 6 16.91 6h-1.637c-.873 0-1.091.727-1.091 1.09v9.82c0 .872.727 1.09 1.09 1.09h1.637c.873 0 1.091-.727 1.091-1.09Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPipelinePause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pipeline-pause.f0c07d95.svg";